//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ASIA_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/Chart_ASIA_info.vue